import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OktaService } from '@engie-group/ngx-gem-spaas';
import { DataGridsHelper } from 'src/app/core/data-grids-helper';
import { AdHocInstructionsGridDTO } from 'src/app/core/Dtos/ad-hoc/instructions-grid-dto';
import { Assets } from 'src/app/core/Dtos/assets-enum';
import { AlertsService } from 'src/app/core/services/alerts.service';
import { DateFormatHelperService } from 'src/app/core/services/date-format-helper.service';
import { MorayEastService } from 'src/app/core/services/moray-east.service';
import { BaseComponent } from 'src/app/features/base-component';

@Component({
    selector: 'app-adhoc-instructions',
    templateUrl: './adhoc-instructions.component.html',
    styleUrl: './adhoc-instructions.component.scss',
    standalone: false
})
export class AdhocInstructionsComponent extends BaseComponent{
  @Output() 
  public OnViewInstruction : EventEmitter<string | number> = new EventEmitter<string | number>();

  @Input()
  public Asset: Assets | null = null;

  @Input("GridData")
  public set CurrentSearchData(data : AdHocInstructionsGridDTO[])
  {
    this.DataGridHelper.GridData = data;
  }

  public Assets = Assets; // export enum
  public DataGridHelper: DataGridsHelper<AdHocInstructionsGridDTO> = new DataGridsHelper<AdHocInstructionsGridDTO>();

  private _addNewRoute: string = "";

  constructor(
    public dateFormatHelper: DateFormatHelperService,
    oktaService: OktaService,
    alertService: AlertsService,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
  ) 
  {
    super(oktaService, alertService, dateFormatHelper);
  }

  ngOnInit() {
    // Get the asset id from the route, otherwise use the @Input
    let assetId = this._activatedRoute.snapshot.routeConfig?.path 
    if (assetId == "" || !(assetId == "moweo" || assetId == "mowwl" || assetId == "fhc" || assetId == "retail"|| assetId == "res")) 
      assetId = this.Asset?.toString().toLowerCase();
    
    switch (assetId) {
      case "moweo":
      case "morayeast":
        this.Asset = Assets.MorayEast;
        this._addNewRoute = "moweo/adhoc-new";
        this.UserData.IsReadOnly = this.UserData.IsReadOnly || !this.UserData.HasMorayEastAccess;
        break;
      case "moraywest":
      case "mowwl":
          this.Asset = Assets.MorayWest;
          this._addNewRoute = "mowwl/adhoc-new";
          this.UserData.IsReadOnly = this.UserData.IsReadOnly || !this.UserData.HasMorayWestAccess;
          break;
      case "fhc":
        this.Asset = Assets.FirstHydro;
        this._addNewRoute = "fhc/adhoc-new";
        this.UserData.IsReadOnly = this.UserData.IsReadOnly || !this.UserData.HasFHCAccess;
        break;
      case "retail":
        this.Asset = Assets.Retail;
        this._addNewRoute = "retail/adhoc-new";
        this.UserData.IsReadOnly = this.UserData.IsReadOnly || !this.UserData.HasRetailAccess;
        break;
      case "res":
        this.Asset = Assets.Res;
        this._addNewRoute = "res/adhoc-new";
        this.UserData.IsReadOnly = this.UserData.IsReadOnly || !this.UserData.HasResAccess;
        break;
    } 
  }

  public ViewInstruction(instructionId:number|string){
    this.OnViewInstruction?.next(instructionId);
  }

  public CopyToNew(instructionId: number | string) {
    let viewingRoute = `${this._addNewRoute}/${instructionId}`;
    this._router.navigate([viewingRoute]);
  }

  public GetClass(startDate: Date | string, endDate: Date | string) {
    let sd = new Date(startDate),
      ed = (endDate ?? "") == "" ? null: new Date(endDate),
      today = new Date();
    
    if (today > sd && (ed == null || today < ed))
      return "day-instruction";

    return "";
  }
}
